import { useEffect, useRef, useState } from "react";

const InputDropdown = ({ options, selected, placeholder, onSelect }) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [isOpen, setIsOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (options && options.length > 0) {
      setFilteredOptions(
        options.filter((option) =>
          option.label?.toLowerCase().includes(inputValue?.toLowerCase()),
        ),
      );
    }
  }, [inputValue, options]);

  useEffect(() => {
    setInputValue(selected);
  }, [selected]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setHighlightedIndex(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setIsOpen(true);
  };

  const handleOptionSelect = (option) => {
    setInputValue(option.label);
    setIsOpen(false);
    setHighlightedIndex(-1);
    onSelect(option);
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev < filteredOptions.length - 1 ? prev + 1 : prev,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : -1));
    } else if (e.key === "Enter" && highlightedIndex >= 0) {
      e.preventDefault();
      handleOptionSelect(filteredOptions[highlightedIndex]);
    } else if (e.key === "Escape") {
      setIsOpen(false);
      setHighlightedIndex(-1);
    }
  };

  return (
    <div className="relative w-full max-w-xs" ref={dropdownRef}>
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onFocus={() => setIsOpen(true)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        className="input input-bordered w-full"
      />
      {isOpen && filteredOptions.length > 0 && (
        <ul className="bg-base-100 border-base-300 absolute z-10 mt-1 max-h-60 w-full overflow-y-auto rounded-lg border shadow-lg">
          {filteredOptions.map((option, index) => (
            <li
              key={option.value}
              onClick={() => handleOptionSelect(option)}
              className={`hover:bg-primary hover:text-primary-content cursor-pointer px-4 py-2 ${
                index === highlightedIndex
                  ? "bg-primary text-primary-content"
                  : ""
              }`}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default InputDropdown;
